import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL, PUT_URL } from '@utils/api/endpoints.ts';
import { DocumentMutationIdentifier } from '@utils/types/editors/transcripts/api.ts';
import { DocumentResult } from '@utils/types/editors/generic.ts';
import { useTranslation } from 'react-i18next';

export function useResetSharedDocument() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const extractTokenFromUrl = () => {
    const url = window.location.href;
    return url.split('/').pop();
  };

  return useMutation(
    async ({
      sessionId,
      documentId
    }: DocumentMutationIdentifier): Promise<DocumentResult> => {
      const token = extractTokenFromUrl();

      if (!token) {
        throw new Error(t('token-not-found-in-url'));
      }

      const resetUrl = `${PUT_URL(sessionId, documentId).resetSharedDocument}?token=${token}`;

      // Reset the document
      await Axios.put(resetUrl);

      // Fetch the fresh document data
      const documentUrl = GET_URL(sessionId, documentId).sharedDocument;
      const { data } = await Axios.get<DocumentResult>(documentUrl, {
        params: { token }
      });

      // Update the query cache with fresh data (without invalidating)
      queryClient.setQueryData(
        ['sharedDocument', sessionId, documentId, token],
        data
      );

      return data;
    }
  );
}
